import request from "@/api";

export function listOrderVerify(data) {
    return request({
        url: '/api/order/getOrderVerifyList',
        method: 'get',
        params: data
    })
}

export function saveOrderVerify(data) {
    return request({
        url: '/api/order/saveOrderVerify',
        method: 'post',
        data: data
    })
}


export function batchSaveOrderCustomerStatus(data) {
    return request({
        url: '/api/order/batchSaveOrderCustomerStatus',
        method: 'post',
        data: data
    })
}

export function batchSaveOrderSupplierStatus(data) {
    return request({
        url: '/api/order/batchSaveOrderSupplierStatus',
        method: 'post',
        data: data
    })
}


export function getOrderVerifyCount(data) {
    return request({
        url: '/api/order/getOrderVerifyCount',
        method: 'get',
        params: data
    })
}
